import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import { NavLink } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  toolbar: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
    },
  },
  tabs: {
    alignItems: 'center',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
    },
  },
  tabLink: {
    fontFamily: 'Gotham',
    fontWeight: 500,
    margin: theme.spacing(0, 2),
    '&:first-child': {
      [theme.breakpoints.up('tablet')]: {
        marginLeft: theme.spacing(0),
      },
    },
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('tablet')]: {
      marginBottom: 0,
    },
    position: 'relative',
    textTransform: 'uppercase',
    textDecoration: 'inherit',
    '&:hover, &.tabLink-active': {
      '&::after': {
        bottom: theme.spacing(-1),
        [theme.breakpoints.up('tablet')]: {
          bottom: theme.spacing(-2),
        },
        content: '""',
        display: 'block',
        position: 'absolute',
        height: 2,
        left: 0,
        right: 0,
      },
    },
  },
  tabLinkGreen: {
    color: theme.palette.darkGreen.main,
    '&:hover, &.tabLink-active': {
      color: theme.palette.lightGreen.main,
      '&::after': {
        backgroundColor: theme.palette.lightGreen.main,
      },
    },
  },
  tabLinkPurple: {
    color: theme.palette.purple.main,
    '&:hover, &.tabLink-active': {
      color: theme.palette.purple.main,
      '&::after': {
        backgroundColor: theme.palette.purple.main,
      },
    },
  },
  tabLinkRed: {
    color: theme.palette.red.main,
    '&:hover, &.tabLink-active': {
      color: theme.palette.red.main,
      '&::after': {
        backgroundColor: theme.palette.red.main,
      },
    },
  },
}))

const Toolbar = ({ children }) => {
  const classes = useStyles()
  return <div className={classes.toolbar}>{children}</div>
}

const ToolbarTabs = ({ color, tabs }) => {
  const classes = useStyles()
  return (
    <div className={classes.tabs}>
      {tabs.map((props, idx) => (
        <ToolbarTabLink color={color} key={idx} {...props} />
      ))}
    </div>
  )
}

const ToolbarTabLink = ({ color = 'green', hasError, label, path, exact }) => {
  const classes = useStyles()
  return (
    <NavLink
      activeClassName="tabLink-active"
      className={clsx(classes.tabLink, {
        [classes.tabLinkGreen]: color === 'green',
        [classes.tabLinkPurple]: color === 'purple',
        [classes.tabLinkRed]: color === 'red',
      })}
      exact={exact}
      to={path}
    >
      {label}
    </NavLink>
  )
}

Toolbar.Tabs = ToolbarTabs
Toolbar.TabLink = ToolbarTabLink

export default Toolbar
